import React from 'react';
import axios from 'axios'
import Chip from '@material-ui/core/Chip';
import Icon from '@material-ui/core/Icon';

function logout() {
  axios.get(`https://nakrutkatop.com:443/api/logout`, {withCredentials: true, credentials: 'same-origin', crossdomain: true  }).then(()=>{
    window.location.reload()
  })
}

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      balance: "..."
    }
  }

  componentDidMount() {
    var width = window.innerWidth;
    if (width <= 768) {
      document.querySelector(".fa-rocket").classList.add("fa-bars")
      document.querySelector(".fa-rocket").classList.remove("fa-rocket")
      document.addEventListener("click", function (e) {
        if (e.target.id == "menuOpenBtn" || e.target.id == "menuIcon") return
        if (~document.querySelector("#sideMenu").classList.value.indexOf("opened")) { // Opened
          document.querySelector("#sideMenu").classList.remove("opened")
          document.querySelector("#menuIcon").style.opacity = 0
          setTimeout(() => {
            document.querySelector("#menuIcon").classList.add("fa-bars")
            document.querySelector("#menuIcon").classList.remove("fa-times")
          }, 100)
          setTimeout(() => { document.querySelector("#menuIcon").style.opacity = 1 }, 200)
        }
      })
    }
    this.props.updateBalance()
   axios.get("https://nakrutkatop.com:443/api/cabinet", { withCredentials: true }).then(res => {
    if(res.data.ok == false){
      document.querySelector('#balanceChip').style.display = 'none'
      document.querySelector('#logoutBtn').style.display = 'none'
      document.querySelector('#loginChip').style.display = 'flex'
      
    } else {
      document.querySelector('#balanceChip').style.display = 'flex'
      document.querySelector('#logoutBtn').style.display = 'flex'
      document.querySelector('#loginChip').style.display = 'none'
    }
   })
  }

  componentDidUpdate() {
      document.querySelector(".headerBalance").setAttribute("data-toggle", "modal")
      document.querySelector(".headerBalance").setAttribute("data-target", "#payinModal")

  }

  render(props) {
    return <header className="mdc-top-app-bar app-bar" style={{ backgroundColor: "#6200ee" }}>
      <div className="mdc-top-app-bar__row">
        <section className="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
          <button className="mdc-top-app-bar__navigation-icon mdc-icon-button" id="menuOpenBtn" onClick={() => {
            if (~document.querySelector("#sideMenu").classList.value.indexOf("opened")) { // Opened
              document.querySelector("#sideMenu").classList.remove("opened")
              document.querySelector("#menuIcon").style.opacity = 0
              setTimeout(() => {
                document.querySelector("#menuIcon").classList.add("fa-bars")
                document.querySelector("#menuIcon").classList.remove("fa-times")
              }, 100)
              setTimeout(() => { document.querySelector("#menuIcon").style.opacity = 1 }, 200)

            } else { // Closed
              document.querySelector("#sideMenu").classList.add("opened")
              document.querySelector("#menuIcon").style.opacity = 0
              setTimeout(() => { document.querySelector("#menuIcon").style.opacity = 1 }, 200)
              setTimeout(() => {
                document.querySelector("#menuIcon").classList.add("fa-times")
                document.querySelector("#menuIcon").classList.remove("fa-bars")
              }, 100)

            }

          }} aria-label="Open navigation menu"><i
            className="fas fa-rocket" id="menuIcon" style={{ transition: "opacity 0.1s ease 0s", opacity: 1 }} ></i></button>
          <span className="mdc-top-app-bar__title" style={{ font: "400 1.75rem/1.75rem 'Aqum', sans-serif" }}><a href="/" style={{ color: "#fff" }}>NakrutkaTOP</a></span>
        </section>
        <section className="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
        <Chip classes={{ root: "headerBalance" }} id='balanceChip' style={{display: 'none'}}
        size="medium" 
        //icon={<Icon style={{ color: "#fff" }}>account_balance_wallet</Icon>}
        deleteIcon={<Icon style={{ color: "#fff" }}>add_circle</Icon>}
        label={this.props.balance + "$"}
       // onClick={()=>{alert("n")}}
        onDelete={()=>{}}
      />
          <button className="material-icons mdc-top-app-bar__action-item mdc-icon-button" aria-label="Выйти" id='logoutBtn' style={{display: 'none'}}  onClick={logout}>exit_to_app</button>
          <Chip classes={{ root: "headerBalance" }} id='loginChip' style={{display: 'none'}}
        size="medium" 
        //icon={<Icon style={{ color: "#fff" }}>account_balance_wallet</Icon>}
        deleteIcon={<></>}
        label={"Войти"}

        onClick={()=>{window.location.href = '/login'}}
        onDelete={()=>{}}
      />
        </section>
      </div>
    </header>
  }
}

export default Header